const SimpleContainer = ({ children }) => {
    return(
        <div className="container p-4">
            {children}
        </div>
    );
}

export default SimpleContainer;